import { useState, useEffect, RefObject } from 'react';
import { $document, $window } from '@umu/umu-dom';
import { debounce } from '@umu/umu-util';

export function useContentHeight(panelBodyRef: RefObject<HTMLDivElement>) {
    const [height, setHeight] = useState(0);

    const getHeight = () => {
        if (panelBodyRef.current) {
            const panelBodyRect = panelBodyRef.current.getBoundingClientRect();
            const h = $document.documentElement.clientHeight - panelBodyRect.top - 20;
            setHeight(h);
        }
    };

    useEffect(() => {
        getHeight();
        const delayUpdateToolbar = debounce(getHeight, 100);
        $window.addEventListener('resize', delayUpdateToolbar);
        return () => {
            $window.removeEventListener('resize', delayUpdateToolbar);
        };
    }, []);

    return [height];
}
